import { API_URL } from '../constants';
import { ICreateNewSectionRequestBody } from './types';
import { fetch } from '../fetchWrapper/fetch';

export const createNewMenuSection = async (
  menuId: string,
  requestBody: ICreateNewSectionRequestBody,
): Promise<Response> => {
  try {
    const res = await fetch(`${API_URL}/menus/${menuId}/sections`, {
      method: 'POST',
      body: JSON.stringify(requestBody),
      headers: {
        'content-type': 'application/json',
      },
    });
    if (!res.ok) throw new Error(res.statusText);
    return res;
  } catch (e) {
    throw new Error('Could not create menu section', { cause: e });
  }
};
